/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from "react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import {
  Box,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
  GridItem,
  Grid,
  TabPanel,
  TabPanels,
  Tabs,
  TabList,
  Tab,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  Modal,
  Text,
  useToast,
  ModalCloseButton,
  ModalBody,
  Button,
  usePrefersReducedMotion,
} from "@chakra-ui/react";
import welcomeFallback from "../assets/img/welcome-fallback.png";
import iplBannerDesktop from "../assets/img/banners/ipl-banner-desktop.png";
import iplBannerMobile from "../assets/img/banners/ipl-banner-mobile.jpeg";
import Header from "../includes/header";
// sidebar/index.js no longer used — Sidebar.js reads from Redux
import DasNAv from "../includes/dasNav";
import { getUserDataAPI } from "../service/UserService";
import { useDispatch, useSelector } from "react-redux";
import ChangePasswordModal from "../components/ChangePasswordModal";
import {
  changeButtonValuesAPI,
  dashboardBannerAPI,
  getAnnouncementAPI,
  getButtonValuesAPI,
  getExposureTableAPI,
  getSignedUrlAPI,
} from "../service/AuthService";
import { buttonColors } from "../utils/constants";
import CustomTable from "../components/Table";
import { useMemo } from "react";
import Sidebar from "../includes/sidebar/Sidebar";
import { useState } from "react";
import Footer from "../includes/footer";
import LastResults from "../components/LastResults";
import MobileHeader from "../includes/header/MobileHeader";
const PrivateOutlet = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const prefersReducedMotion = usePrefersReducedMotion();
  const userData = useSelector((state) => state.account.userData);
  const selectedEventForBet = useSelector(
    (state) => state?.gameData?.selectedEventForBet
  );
  const [buttons, setButtons] = React.useState({});
  const [announcement, setAnnouncement] = React.useState({});
  const getAnnouncement = async () => {
    const res = await getAnnouncementAPI();
    if (res.code === 200) {
      setAnnouncement(res.response);
    }
  };
  const handleUpdate = (key, value) => {
    setButtons((prev) => ({ ...prev, [key]: value }));
  };
  const getButtonValues = async () => {
    const res = await getButtonValuesAPI();
    if (res.code === 200) {
      setButtons(res.response);
    }
  };
  const handleSave = async () => {
    const res = await changeButtonValuesAPI(buttons);

    if (res.code === 200) {
      toast({
        title: "Success",
        description: "Button values updated successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top",
      });
    }
    getButtonValues();
  };

  useEffect(() => {
    if (!userData?.resetRequired) {
      getButtonValues();
    }
  }, []);
  const dispatch = useDispatch();
  const toast = useToast();
  const location = useLocation();
  const isChangeButtonPopOpen = useSelector(
    (state) => state.account.ui.changeButtonPopOpen
  );
  const isMyMarketPopOpen = useSelector(
    (state) => state.account.ui.myMarketPopOpen
  );
  const [exposureTable, setExposureTable] = React.useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [welcomeOpen, setWelcomeOpen] = useState(false);
  const [welcomeBannerUrl, setWelcomeBannerUrl] = useState("");

  const fetchWelcomeBanner = async () => {
    try {
      const res = await dashboardBannerAPI();
      if (res.code === 200 && res.response?.length > 0) {
        const urlRes = await getSignedUrlAPI(res.response[0].bannerUrl);
        if (urlRes.code === 200) {
          setWelcomeBannerUrl(urlRes.response);
        }
      }
    } catch (e) {
      // fallback to static banner via CSS
    }
  };

  const handleCloseWelcomeOpen = () => {
    localStorage.setItem("welcome", "closed");
    setWelcomeOpen(false);
  };
  const handleOpenWelcomeOpen = () => {
    fetchWelcomeBanner();
    setWelcomeOpen(true);
  };

  const getExposureTable = async () => {
    var res = await getExposureTableAPI();
    if (res.code === 200) {
      setExposureTable(res.response);
    }
  };
  useEffect(() => {
    if (userData.token && userData.token != null && !userData.resetRequired) {
      getExposureTable();

      // PERFORMANCE FIX: Removed 5-second polling to prevent API overload
      // With 5000 users, this was causing 60,000 requests/minute
      // TODO: Implement WebSocket-based user data updates from backend
      // For now, user data is fetched once on mount only

      /* REMOVED POLLING:
      let interval = setInterval(() => {
        getUserData();
      }, 5000);
      return () => clearInterval(interval);
      */

      // Fetch user data once on mount
      getUserData();
    }
  }, []);

  const getUserData = async () => {
    try {
      var res = await getUserDataAPI(userData.id);
      if (res && res?.code === 200) {
        dispatch({
          type: "accountData/setUserProfile",
          payload: res.response,
        });
      }
      // Don't logout on network errors, timeouts, or 500s.
      // The Axios 401 interceptor in service/index.js handles
      // actual auth failures (expired token) and triggers logout there.
    } catch (e) {
      // Network error or timeout — silently ignore.
      // User stays logged in; data refreshes on next successful call.
    }
  };
  useEffect(() => {
    if (!userData?.resetRequired) {
      getAnnouncement();
    }
  }, []);

  useEffect(() => {
    document.body.classList.add("private-layout");
    return () => document.body.classList.remove("private-layout");
  }, []);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }
  }, [isSidebarOpen]);

  if (!userData.token) {
    return (window.location.href = "/");
  }

  useEffect(() => {
    const welcomeClosed = localStorage.getItem("welcome");
    if (!welcomeClosed && !userData?.resetRequired) {
      handleOpenWelcomeOpen();
    }
  }, [userData?.resetRequired]);

  return (
    <>
      <Box display={{ base: "block", md: "none" }}>
        <MobileHeader
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </Box>
      <Box display={{ base: "none", md: "block" }}>
        <Header setIsSidebarOpen={setIsSidebarOpen} />
      </Box>
      <div className="private-layout-scroll">
        <div className="container-fluid container-fluid-5 snipcss-fJ9mV">
          <div className="row row5">
            <Sidebar
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
            {isSidebarOpen && (
              <Box
                className="sidebar-backdrop"
                display={{ base: "block", md: "none" }}
                onClick={() => setIsSidebarOpen(false)}
                aria-hidden="true"
              />
            )}
            <Box className="content-box-main">{props.children}</Box>
          </div>
        </div>
        <Footer />
      </div>
      <ChangePasswordModal />
      <Modal
        size={"lg"}
        onClose={() =>
          dispatch({
            type: "accountData/setChangeButtonState",
            payload: false,
          })
        }
        isOpen={isChangeButtonPopOpen}
        motionPreset="slideInBottom"
      >
        <ModalOverlay />
        <ModalContent marginTop={10} bg="var(--modal-bg)">
          <ModalHeader bg="var(--modal-header-bg)" p="1" borderRadius={"5px"}>
            <Text fontSize="sm" color="var(--text-highlight)">
              Set Button Value
            </Text>
          </ModalHeader>
          <ModalCloseButton color="var(--modal-text)" />
          <ModalBody p="2" bg="var(--modal-bg)">
            <Button onClick={handleSave} mt="10px" w={"100%"} bg={buttonColors}>
              Submit
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal
        size={"4xl"}
        onClose={() =>
          dispatch({
            type: "accountData/setMyMarketPopState",
            payload: false,
          })
        }
        isOpen={isMyMarketPopOpen}
        motionPreset="slideInBottom"
      >
        <ModalOverlay />
        <ModalContent marginTop={10} bg="var(--modal-bg)">
          <ModalHeader bg="var(--modal-header-bg)" p="1" borderRadius={"5px"}>
            <Text fontSize="sm" color="#e8a317">
              My Market
            </Text>
          </ModalHeader>
          <ModalCloseButton color="var(--modal-text)" />
          <ModalBody p="2" bg="var(--modal-bg)" borderRadius={"5px"}>
            <CustomTable
              rows={exposureTable}
              rowsPerPage_={20}
              showPagination={false}
              totalPages_={1}
              currentPage_={0}
              columns={[
                {
                  name: "Event Type",
                  id: "eventType",
                },
                {
                  name: "Event Name",
                  id: "eventName",
                },
                {
                  name: "Match Name",
                  id: "marketName",
                },
                {
                  name: "Trade",
                  id: "trade",
                },
              ]}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      {welcomeOpen && (
        <Modal isOpen={welcomeOpen} onClose={handleCloseWelcomeOpen} size={{ base: "sm", md: "4xl" }} isCentered blockScrollOnMount={false} trapFocus={false}>
          <ModalOverlay bg="rgba(0,0,0,0.75)" />
          <ModalContent bg="var(--theme1-bg)" borderRadius="8px" overflow="hidden" maxW={{ base: "95vw", md: "900px" }} p="0" m="0">
            <Box display="flex" justifyContent="flex-end" alignItems="center" bg="var(--theme1-bg)" px="12px" py="6px">
              <Box as="button" onClick={handleCloseWelcomeOpen} color="#fff" fontSize="22px" fontWeight="bold" lineHeight="1" cursor="pointer" bg="none" border="none" p="0" _hover={{ opacity: 0.7 }}>
                &#x2715;
              </Box>
            </Box>
            <ModalBody p="0">
              <Box display={{ base: "none", md: "block" }}>
                <img
                  src={iplBannerDesktop}
                  alt="IPL 2026 Banner"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
              <Box display={{ base: "block", md: "none" }}>
                <img
                  src={iplBannerMobile}
                  alt="IPL 2026 Banner"
                  style={{ width: "100%", maxHeight: "70vh", objectFit: "cover", objectPosition: "top center", display: "block" }}
                />
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default PrivateOutlet;
